export default __webpack_public_path__ + "static/media/foodIcon.5206d2ca.svg";